import { AutogenModelRecurringOrder, AutogenRowRecurringOrder } from "./autogen/AutogenModelRecurringOrder";

export class ModelRecurringOrder extends AutogenModelRecurringOrder<RowRecurringOrder> {
    constructor() {
        super(RowRecurringOrder);
    }
}

export class RowRecurringOrder extends AutogenRowRecurringOrder {
}